/**
 * 站点共享导航配置
 * 所有推广页都从这里读取，保证 Navbar / Footer 一致性。
 * 链接一律带站点 base 前缀 + hash，这样从任意子页面都能正确跳回首页锚点。
 *
 * BASE 由 webpack DefinePlugin 注入（见 webpack.config.js 的 SITE_BASE）：
 *   域名根路径部署 -> '/'
 *   项目站子路径部署 -> '/<repo-name>/'
 */
/* global __SITE_BASE__ */

const BASE = typeof __SITE_BASE__ === 'undefined' ? '/' : __SITE_BASE__;

/** 站点 base 前缀，页面拼接 static 资源路径时使用（如 `${SITE_BASE}images/lyznote/hero.png`） */
export const SITE_BASE = BASE;

export const SITE_NAME = '书阁园';

export const BRAND = {
  text: SITE_NAME,
  href: BASE,
};

// 产品切换器：顶栏在各推广产品之间跳转，末两项为联系作者与隐私政策
export const NAV_LINKS = [
  { key: 'lyznote', text: 'LYZNote', href: BASE },
  { key: 'lyzdownload', text: 'LYZDownload', href: `${BASE}lyzdownload/` },
  { key: 'jianlu', text: '简录 JianLu', href: `${BASE}jianlu/` },
  { key: 'contact', text: '联系作者', href: `${BASE}contact/` },
  { key: 'privacy', text: '隐私政策', href: `${BASE}privacy/` },
];

export const FOOTER_LINKS = [
  { text: 'LYZNote', href: BASE },
  { text: 'LYZDownload', href: `${BASE}lyzdownload/` },
  { text: '简录 JianLu', href: `${BASE}jianlu/` },
  { text: '联系作者', href: `${BASE}contact/` },
  { text: '隐私政策', href: `${BASE}privacy/` },
];

export const COPYRIGHT = `© ${new Date().getFullYear()} ${SITE_NAME}. All rights reserved.`;
